import { LogParameter, getLogParameter } from '../api/logParameterApi';
import { useLoginContext } from 'components/providers/loginContext';
import { useState } from 'react';

// 指定した WF アプリの実行ジョブのログを取得する
export function useGetLogParameter(): [
  (id: string, ioFlg: string) => Promise<void>,
  LogParameter[] | undefined,
  boolean,
  boolean,
] {
  const loginContext = useLoginContext();
  const [logParameter, setLogParameter] = useState<
    LogParameter[] | undefined
  >();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleGetLogParameter = async (
    id: string,
    ioFlg: string,
  ): Promise<void> => {
    // 初期値設定
    setLogParameter(undefined);
    setLoading(true);
    setError(false);

    try {
      // ローディング中に再実行された場合処理しない
      if (loading) return;
      // 実行ログ情報取得
      const result = await getLogParameter(id, ioFlg, loginContext);

      // データが入っていないパターンは基本存在しないためエラーとする
      if (result.length === 0) {
        throw new Error('no data');
      }
      setLoading(false);
      setError(false);
      setLogParameter(result);
    } catch (e) {
      setLoading(false);
      setError(true);
      return;
    }
  };

  return [handleGetLogParameter, logParameter, loading, error];
}
